import React, { useState } from 'react';
import {
  Box,
  Typography,
  Container,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import {
  BugReport as BugReportIcon,
  Science as ScienceIcon,
  Build as BuildIcon
} from '@mui/icons-material';

import StagingDebugTools from './school_processor_v2/components/testing/StagingDebugTools';
import ServiceTester from './school_processor_v2/components/testing/ServiceTester';

const AdminDebugTools = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedService, setSelectedService] = useState(null);

  const handleServiceSelection = (service) => {
    setSelectedService(service);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2,
          color: 'error.main' 
        }}>
          <BugReportIcon fontSize="large" />
          Debug Tools
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Diagnostic and debugging tools for troubleshooting system issues and testing services
        </Typography>
      </Box>

      {/* Debug Tool Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant="fullWidth"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            icon={<BuildIcon />}
            label="System Diagnostics"
            iconPosition="start"
            sx={{ 
              minHeight: 64,
              textTransform: 'none',
              '&.Mui-selected': {
                color: 'error.main'
              }
            }}
          />
          <Tab
            icon={<ScienceIcon />}
            label="Service Testing"
            iconPosition="start"
            sx={{ 
              minHeight: 64,
              textTransform: 'none',
              '&.Mui-selected': {
                color: 'primary.main'
              }
            }}
          />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      {activeTab === 0 ? (
        <StagingDebugTools />
      ) : (
        <ServiceTester 
          selectedService={selectedService}
          onServiceSelect={handleServiceSelection}
        />
      )}
    </Container>
  );
};

export default AdminDebugTools;
